<template>
    <transition name="fade" mode="out-in">
        <base-modal v-if="visible" :title="title" height="85vh" @close="$emit('close')">
            <div class="flex flex-col h-full min-h-0 px-8 pt-4">
                <div v-if="!loading && hasRows" class="flex justify-end mb-3">
                    <button type="button" class="cp-dd-export-btn" @click.stop="exportExcel">
                        <font-awesome-icon :icon="['fas', 'file-excel']" class="cp-dd-export-btn__icon" />
                        <span>Export Excel</span>
                    </button>
                </div>
                <div v-if="loading" class="flex flex-1 min-h-0 items-center justify-center py-16">
                    <base-spinner></base-spinner>
                </div>
                <div v-else-if="hasRows" class="flex-1 flex flex-col min-h-0 overflow-hidden">
                    <div class="overflow-x-auto overflow-y-auto flex-1 border rounded">
                        <table class="min-w-full text-left text-sm">
                            <thead class="bg-gray-50 border-b sticky top-0">
                                <tr>
                                    <th class="px-4 py-2 text-gray-600">#</th>
                                    <th class="px-4 py-2 text-gray-600">Name</th>
                                    <th class="px-4 py-2 text-gray-600">Student ID</th>
                                    <th class="px-4 py-2 text-gray-600">EID</th>
                                    <th class="px-4 py-2 text-gray-600">Email</th>
                                    <th class="px-4 py-2 text-gray-600">Phone</th>
                                    <th class="px-4 py-2 text-gray-600">Entity</th>
                                    <th class="px-4 py-2 text-gray-600">Campus</th>
                                    <th class="px-4 py-2 text-gray-600">Program</th>
                                    <th class="px-4 py-2 text-gray-600">Academic year</th>
                                    <th class="px-4 py-2 text-gray-600">Current status</th>
                                    <th class="px-4 py-2 text-gray-600">Employer</th>
                                    <th class="px-4 py-2 text-gray-600">Position</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, idx) in students"
                                    :key="row.student_id + '-cp-dd-' + idx"
                                    class="border-b border-gray-100"
                                >
                                    <td class="px-4 py-2 whitespace-nowrap">{{ firstItem + idx }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.name || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.student_id || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.eid || "—" }}</td>
                                    <td class="px-4 py-2">{{ row.email || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.phone || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.entity || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.campus || "—" }}</td>
                                    <td class="px-4 py-2">{{ row.program || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.academic_year || "—" }}</td>
                                    <td class="px-4 py-2 whitespace-nowrap">{{ row.current_status || "—" }}</td>
                                    <td class="px-4 py-2">{{ row.employer || "—" }}</td>
                                    <td class="px-4 py-2">{{ row.position || "—" }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mt-3 shrink-0">
                        <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                    </div>
                </div>
                <div v-else class="flex flex-1 min-h-0 items-center justify-center py-16 text-gray-500">
                    No alumni found for this selection.
                </div>
            </div>
        </base-modal>
    </transition>
</template>

<script>
import gql from "graphql-tag";
import xlsx from "xlsx/dist/xlsx.full.min.js";
import Pagination from "../../../components/shared/pagination.vue";

const DRILLDOWN_QUERY = gql`
    query GetCurrentPartnerEmploymentDrilldown(
        $token: String!
        $breakdown: String!
        $label: String!
        $page: Int!
        $first: Int!
    ) {
        getCurrentPartnerEmploymentDrilldown(
            token: $token
            breakdown: $breakdown
            label: $label
            page: $page
            first: $first
        ) {
            error
            message
            data {
                students {
                    name
                    student_id
                    eid
                    email
                    phone
                    entity
                    campus
                    program
                    academic_year
                    current_status
                    employer
                    position
                }
                paginatorInfo {
                    count
                    currentPage
                    firstItem
                    hasMorePages
                    lastItem
                    lastPage
                    perPage
                    total
                }
            }
        }
    }
`;

var EXPORT_COLUMNS = [
    { key: "name", header: "NAME" },
    { key: "student_id", header: "STUDENT ID" },
    { key: "eid", header: "EID" },
    { key: "email", header: "EMAIL" },
    { key: "phone", header: "PHONE" },
    { key: "entity", header: "ENTITY" },
    { key: "campus", header: "CAMPUS" },
    { key: "program", header: "PROGRAM" },
    { key: "academic_year", header: "ACADEMIC YEAR" },
    { key: "current_status", header: "CURRENT STATUS" },
    { key: "employer", header: "EMPLOYER" },
    { key: "position", header: "POSITION" },
];

function mapPartnerEmploymentExportRow(obj) {
    return {
        name: obj.name || "",
        student_id: obj.student_id || "",
        eid: obj.eid || "",
        email: obj.email || "",
        phone: obj.phone || "",
        entity: obj.entity || "",
        campus: obj.campus || "",
        program: obj.program || "",
        academic_year: obj.academic_year || "",
        current_status: obj.current_status || "",
        employer: obj.employer || "",
        position: obj.position || "",
    };
}

function runDetachedPartnerEmploymentExport(ctx) {
    var store = ctx.store;
    var apolloClient = ctx.apolloClient;
    var jobId = ctx.jobId;
    var fileName = ctx.fileName;
    var variables = ctx.variables;
    var sheetLabel = ctx.sheetLabel;

    var allRows = [];
    var page = 1;
    var limit = 200;

    function fetchNext() {
        var vars = {
            token: variables.token,
            breakdown: variables.breakdown,
            label: variables.label,
            page: page,
            first: limit,
        };

        apolloClient
            .query({
                query: DRILLDOWN_QUERY,
                fetchPolicy: "network-only",
                variables: vars,
            })
            .then(function (result) {
                var payload =
                    result && result.data && result.data.getCurrentPartnerEmploymentDrilldown
                        ? result.data.getCurrentPartnerEmploymentDrilldown
                        : null;

                if (!payload || payload.error) {
                    throw new Error(
                        (payload && payload.message) ? payload.message : "Server error"
                    );
                }

                var data = payload.data || {};
                var batch = data.students || [];
                var paginator = data.paginatorInfo || {};

                if (batch.length > 0) {
                    for (var i = 0; i < batch.length; i++) {
                        allRows.push(mapPartnerEmploymentExportRow(batch[i]));
                    }

                    var total = paginator.total || allRows.length;
                    var percent = total > 0
                        ? Math.min(95, Math.round((allRows.length / total) * 100))
                        : Math.min(95, Math.round(
                            (allRows.length / Math.max(allRows.length + limit, 1)) * 100
                        ));

                    store.dispatch("exportManager/updateJob", {
                        id: jobId,
                        progress: percent,
                        currentSheet: sheetLabel + " (" + allRows.length + " rows)",
                    });
                }

                if (paginator.hasMorePages) {
                    page = page + 1;
                    fetchNext();
                } else {
                    finishExport();
                }
            })
            .catch(function (error) {
                if (allRows.length > 0) {
                    finishExport();
                } else {
                    store.dispatch("exportManager/failJob", {
                        id: jobId,
                        error: (error && error.message) ? error.message : "Export failed",
                    });
                }
            });
    }

    function finishExport() {
        try {
            if (allRows.length === 0) {
                store.dispatch("exportManager/failJob", {
                    id: jobId,
                    error: "No data available for export",
                });
                return;
            }

            var colKeys = EXPORT_COLUMNS.map(function (col) {
                return col.key;
            });

            var rows = allRows.map(function (row) {
                var out = {};
                for (var i = 0; i < EXPORT_COLUMNS.length; i++) {
                    var key = EXPORT_COLUMNS[i].key;
                    out[key] = row[key] !== undefined && row[key] !== null ? row[key] : "";
                }
                return out;
            });

            var worksheet = xlsx.utils.json_to_sheet(rows, { header: colKeys });

            var columnWidths = [];
            for (var c = 0; c < EXPORT_COLUMNS.length; c++) {
                var column = String.fromCharCode(65 + (c % 26));
                var r = Math.floor(c / 26);
                var columnLetter = r > 0 ? String.fromCharCode(64 + r) + column : column;
                worksheet[columnLetter + "1"] = { v: EXPORT_COLUMNS[c].header, t: "s" };
                columnWidths.push({ width: Math.max(16, EXPORT_COLUMNS[c].header.length + 5) });
            }

            worksheet["!cols"] = columnWidths;

            var workbook = xlsx.utils.book_new();
            xlsx.utils.book_append_sheet(workbook, worksheet, "Alumni");
            xlsx.writeFile(workbook, fileName);

            store.dispatch("exportManager/completeJob", {
                id: jobId,
                rowCount: allRows.length,
            });
        } catch (error) {
            store.dispatch("exportManager/failJob", {
                id: jobId,
                error: (error && error.message) ? error.message : "Export failed",
            });
        }
    }

    fetchNext();
}

export default {
    name: "PartnerEmploymentDrilldownModal",
    components: {
        Pagination: Pagination,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Alumni Details",
        },
        fileName: {
            type: String,
            default: "Partner_Employment_Drilldown",
        },
        partnerToken: {
            type: String,
            required: true,
        },
        breakdown: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "",
        },
    },
    emits: ["close"],
    data: function () {
        return {
            loading: false,
            students: [],
            paginatorInfoData: null,
            pageSize: 10,
        };
    },
    computed: {
        hasRows: function () {
            if (this.paginatorInfoData && this.paginatorInfoData.total > 0) {
                return true;
            }
            return this.students && this.students.length > 0;
        },
        paginatorInfo: function () {
            if (this.paginatorInfoData) {
                return this.paginatorInfoData;
            }
            return {
                count: 0,
                currentPage: 1,
                firstItem: 0,
                hasMorePages: false,
                lastItem: 0,
                lastPage: 1,
                perPage: this.pageSize,
                total: 0,
            };
        },
        firstItem: function () {
            var info = this.paginatorInfo;
            return info && info.firstItem ? info.firstItem : 1;
        },
    },
    watch: {
        visible: function (isVisible) {
            if (isVisible) {
                this.fetchStudents(1);
            } else {
                this.students = [];
                this.paginatorInfoData = null;
            }
        },
        breakdown: function () {
            if (this.visible) {
                this.fetchStudents(1);
            }
        },
        label: function () {
            if (this.visible) {
                this.fetchStudents(1);
            }
        },
    },
    methods: {
        setPage: function (page) {
            this.fetchStudents(page);
        },
        async fetchStudents(pageNo) {
            if (!this.partnerToken || !this.breakdown || !this.label) {
                this.students = [];
                this.paginatorInfoData = null;
                return;
            }

            this.loading = true;
            try {
                var response = await this.$apollo.query({
                    query: DRILLDOWN_QUERY,
                    variables: {
                        token: this.partnerToken,
                        breakdown: this.breakdown,
                        label: this.label,
                        page: pageNo || 1,
                        first: this.pageSize,
                    },
                    fetchPolicy: "network-only",
                });

                var payload =
                    response.data && response.data.getCurrentPartnerEmploymentDrilldown
                        ? response.data.getCurrentPartnerEmploymentDrilldown
                        : null;

                if (!payload || payload.error) {
                    this.students = [];
                    this.paginatorInfoData = null;
                    return;
                }

                var data = payload.data || {};
                this.students = data.students || [];
                this.paginatorInfoData = data.paginatorInfo || null;
            } catch (error) {
                console.error("Failed to load partner employment drilldown:", error);
                this.students = [];
                this.paginatorInfoData = null;
            }
            this.loading = false;
        },
        exportExcel: function () {
            if (!this.partnerToken || !this.breakdown || !this.label) {
                return;
            }

            var store = this.$store;
            var apolloClient = this.$apollo && this.$apollo.provider
                ? this.$apollo.provider.defaultClient
                : null;
            if (!apolloClient) {
                return;
            }

            var safeName = String(this.fileName || "Partner_Employment_Drilldown").replace(/[^\w-]+/g, "_");
            var fileName = safeName + ".xlsx";
            var sheetLabel = this.title || "Employment Drilldown";

            var variablesCopy = {
                token: this.partnerToken,
                breakdown: this.breakdown,
                label: this.label,
            };

            store
                .dispatch("exportManager/addJob", {
                    fileName: fileName,
                    totalSheets: 1,
                })
                .then(function (jobId) {
                    store.dispatch("exportManager/setMinimized", false);
                    store.dispatch("exportManager/updateJob", {
                        id: jobId,
                        progress: 5,
                        currentSheet: sheetLabel,
                    });

                    runDetachedPartnerEmploymentExport({
                        store: store,
                        apolloClient: apolloClient,
                        jobId: jobId,
                        fileName: fileName,
                        variables: variablesCopy,
                        sheetLabel: sheetLabel,
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.cp-dd-export-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    white-space: nowrap;
    border-radius: 0.75rem;
    border: 1px solid rgba(16, 185, 129, 0.25);
    background: linear-gradient(to bottom, #ffffff, rgba(16, 185, 129, 0.08));
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #052e1f;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.cp-dd-export-btn:hover {
    border-color: rgba(16, 185, 129, 0.45);
    background: linear-gradient(to bottom, rgba(16, 185, 129, 0.08), rgba(16, 185, 129, 0.14));
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
}

.cp-dd-export-btn:disabled {
    pointer-events: none;
    opacity: 0.6;
}

.cp-dd-export-btn__icon {
    font-size: 1.05rem;
    color: #059669;
    filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.06));
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
